import React, { useEffect } from 'react';
import FadeIn from '../components/ui/FadeIn';

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-44 pb-24 bg-warmWhite min-h-screen">
      <div className="container mx-auto px-6 max-w-4xl">
        <FadeIn>
          <h1 className="font-heading text-5xl font-bold mb-12 text-charcoal">Privacy Policy</h1>
          
          <div className="prose prose-slate max-w-none space-y-8 text-gray-600 font-light leading-relaxed">
            <section>
              <h2 className="text-2xl font-heading font-semibold text-charcoal mb-4">Information We Collect</h2>
              <p>We collect information you provide directly to us when you create an account, place an order, or contact us for support. This may include your name, business name, floral license information (for tax exemption), email address, phone number, and shipping address.</p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-charcoal mb-4">How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Process and fulfill your vase orders.</li>
                <li>Communicate with you about your orders and account.</li>
                <li>Verify your reseller status for tax-exempt pricing.</li>
                <li>Send you updates about new designs (you may opt out at any time).</li>
                <li>Improve our website and customer experience.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-charcoal mb-4">Data Security</h2>
              <p>We implement industry-standard security measures to protect your personal information. Payment processing is handled by secure, PCI-compliant third-party providers. We never store your full credit card information on our servers.</p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-charcoal mb-4">Contact Us</h2>
              <p>If you have any questions about this Privacy Policy or our treatment of your data, please contact us at:</p>
              <p className="mt-2 font-medium">SmileVase<br />Phone: 602-805-5051<br />Email: hi@smilevase.com</p>
            </section>
          </div>
        </FadeIn>
      </div>
    </div>
  );
}